import styles from './SobreAEmpresa.module.css';
import ParticlesBackground from '../../components/ParticlesBackground/ParticlesBackground';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import PageSEO from '../../components/PageSEO/PageSEO';

const reveal = (delay = 0) => ({
  initial: { opacity: 0, y: 26 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] },
});

function SobreAEmpresa() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.slice(0, 2) || 'pt';

  return (
    <>
      <PageSEO
        title="Sobre a Empresa"
        description="A história da SteinSoft: de uma empresa de alocação de profissionais Delphi a uma software house com produtos próprios como Simão Menu, Elohim e Sanarix."
        path="/SobreAEmpresa"
        lang={lang}
      />
      <div className={styles.particles}>
        <ParticlesBackground />
      </div>

      <div className={styles.page}>

        {/* ── Hero ── */}
        <section className={styles.hero}>
          <motion.span className={styles.eyebrow} {...reveal()}>
            {t('empresa.eyebrow')}
          </motion.span>
          <motion.h1 className={styles.heroTitle} {...reveal(0.1)}>
            {t('empresa.tituloBase')} <span className={styles.accent}>{t('empresa.tituloAcc')}</span>
          </motion.h1>
          <motion.p className={styles.heroSub} {...reveal(0.2)}>
            {t('empresa.subtitulo')}
          </motion.p>
        </section>

        {/* ── Conteúdo ── */}
        <section className={styles.section}>
          <div className={styles.content}>

            {/* Imagem */}
            <motion.div className={styles.imageWrap} {...reveal(0.1)}>
              <div className={styles.imageFrame}>
                <img src="/IGREJAARTHUR.png" alt="Arthur Steinbach — CEO SteinSoft" />
              </div>
            </motion.div>

            {/* Texto */}
            <motion.div className={styles.textWrap} {...reveal(0.2)}>
              <h2 className={styles.storyTitle}>
                {t('empresa.historiaBase')} <span className={styles.accent}>{t('empresa.historiaAcc')}</span>
              </h2>

              <div className={styles.paragraphs}>
                <p>{t('empresa.p1')}</p>
                <p>{t('empresa.p2')}</p>
                <p>{t('empresa.p3')}</p>
                <p>{t('empresa.p4')}</p>
              </div>

              <div className={styles.signature}>
                <span className={styles.sigName}>Arthur Steinbach</span>
                <span className={styles.sigRole}>{t('empresa.fundadorCeo')}</span>
              </div>
            </motion.div>

          </div>
        </section>

      </div>
    </>
  );
}

export default SobreAEmpresa;
